<template>
  <div class="status-select">
    <button
      class="status-select__button"
      v-click-outside="() => (isOpen = false)"
      ref="statusButton"
      :class="[
        { green: status.class === 'green' },
        { red: status.class === 'red' }
      ]"
      @click.stop="isOpen = !isOpen"
    >
      <div class="status-select__button__arrow" :class="{ 'is-open': isOpen }">
        <icon name="arrow-down-icon"></icon>
      </div>
      <div
        class="status-select__button__text"
        :class="[
          { green_text: status.class === 'green' },
          { red_text: status.class === 'red' }
        ]"
      >
        {{ status.text }}
      </div>
      <div
        class="status-select__button__status"
        :class="[
          { green: status.class === 'green' },
          { red: status.class === 'red' }
        ]"
      ></div>
    </button>
    <ul class="status-select__list" ref="statusMenu">
      <li
        v-for="item in items"
        :key="item.id"
        class="status-select__list__item"
        @click.stop="selectedContext(item)"
        :class="[
          { green: item.class === 'green' },
          { red: item.class === 'red' }
        ]"
      >
        <div
          class="status-select__list__item__text"
          :class="[
            { green_text: item.class === 'green' },
            { red_text: item.class === 'red' }
          ]"
        >
          {{ item.text }}
        </div>
        <div
          class="status-select__list__item__status"
          :class="[
            { green: item.class === 'green' },
            { red: item.class === 'red' }
          ]"
        ></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { tippy } from 'vue-tippy';
export default {
  props: {
    items: Array,
    statusSelect: [Object]
  },
  data() {
    return {
      isOpen: false,
      statusTitle: 'פעיל',
      status: 1
    };
  },

  mounted() {
    this.tippyInstance = tippy(this.$refs.statusButton, {
      content: this.$refs.statusMenu,
      placement: 'bottom-start',
      trigger: 'click',
      interactive: true,
      hideOnClick: true
    });
    if (this.statusSelect && this.statusSelect.text) {
      this.status = this.statusSelect;
    } else {
      this.status = this.items[0];
    }
  },
  methods: {
    selectedContext(item) {
      this.status = item;
      this.$emit('selectStatus', this.status);
      this.tippyInstance.hide();
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.tippy-backdrop {
  background-color: #ffffff !important;
}
.status-select {
  .green {
    background: #eaffee;
  }
  .red {
    background: #ffe8e5;
  }
  position: relative;
  &__button {
    margin-top: 4px;
    margin-bottom: 4px;
    padding-bottom: 8px;
    padding-top: 8px;
    padding-right: 8px;
    gap: 8px;
    border-radius: 16px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #000000;
    cursor: pointer;
    display: flex;
    text-align: right;
    align-items: center;
    width: 115px;
    border: none;
    &__text {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
    &__arrow {
      position: absolute;
      top: 49%;
      transform: translateY(-50%);
      left: 12px;
      stroke: #5a6f95;
      width: 16px;
      height: 16px;
      svg {
        width: 100%;
        height: 100%;
        transition: 0.3s;
      }
      &.is-open {
        svg {
          transform: rotateX(180deg);
        }
      }
    }
    .green {
      background: #29cc44;
    }
    .red {
      background: #ff3826;
    }
    .green_text {
      color: #29cc44;
    }
    .red_text {
      color: #ff3826;
    }
    &__status {
      border-radius: 10px;
      width: 12px;
      height: 12px;
    }
    &__text {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
    // svg {
    //   transform: rotate(90deg);
    // }
  }
  &__list {
    width: 115px;
    background: #ffffff;
    border-radius: 12px;
    // padding: 0 14px;
    z-index: 1;
    box-shadow: 0px 8px 20px -4px rgba(56, 69, 93, 0.08),
      0px 4px 12px -4px rgba(56, 69, 93, 0.04);
    .green {
      background: #eaffee;
    }
    .red {
      background: #ffe8e5;
    }
    &__item {
      .green {
        background: #29cc44;
      }
      .red {
        background: #ff3826;
      }
      .green_text {
        color: #29cc44;
      }
      .red_text {
        color: #ff3826;
      }
      &__status {
        border-radius: 10px;
        width: 12px;
        height: 12px;
      }
    }
    li {
      margin-top: 4px;
      margin-bottom: 4px;
      padding-bottom: 8px;
      padding-top: 8px;
      padding-right: 8px;
      gap: 8px;
      border-radius: 16px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #000000;
      cursor: pointer;
      display: flex;
      text-align: right;
      align-items: center;
    }
  }
}
</style>
